<mat-toolbar class="subtitulo">Beneficiário {{ aluno?.pessoaFisica?.nome ? (' - ' + aluno?.pessoaFisica?.nome) : '' }}
</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <mat-horizontal-stepper fxFlex #stepper (keydown.enter)="tratarEnter($event)"
                            (keydown.control.arrowright)="mudarAbaComControlSeta($event, stepper, 1)"
                            (keydown.control.arrowleft)="mudarAbaComControlSeta($event, stepper, -1)"
                            style="background: transparent; padding: 10px; width: 100%; max-width: 100%;">

        <!------------------ DADOS PESSOAIS ------------------------>
        <mat-step [stepControl]="formCadastroDadosPessoais">
            <form #formCadastroDadosPessoais="ngForm">
                <ng-template matStepLabel>DADOS PESSOAIS</ng-template>

                <dados-pessoais-aluno [familiar]="familiar" [pessoaFisica]="aluno.pessoaFisica"
                                (pesquisaPessoaFisica)="carregarPessoaFisica($event)"></dados-pessoais-aluno>

                <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                     fxFlexFill>
                    <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </form>
        </mat-step>

        <!--  INCLUSÃO -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formCadastroAcademico">
            <form #formCadastroAcademico="ngForm">
                <ng-template matStepLabel>INCLUSÃO</ng-template>
                <academico [aluno]="aluno"></academico>
                <escolaridade [aluno]="aluno" [pessoaFisica]="aluno.pessoaFisica"></escolaridade>
                <escolar-aluno [aluno]="aluno"></escolar-aluno>
            </form>

            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                 fxFlexFill>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>

        </mat-step>

        <!-- ------------------ FAMILIAR ------------------------ -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formCadastroFamiliar">
            <form #formCadastroFamiliar="ngForm">
                <ng-template matStepLabel>FAMILIAR</ng-template>
                <div *ngIf="responsavel">
                    <dados-pessoais-familiar-aluno [pessoaFisica]="familiar.pessoasFisica" [familiar]="familiar"
                                                   [responsavel]="responsavel"
                                                   (pesquisaPessoaFisica)="carregarFamiliarPessoaFisica($event)"
                                                   (copiarEndereco)="copiarEnderecoBeneficiario()"></dados-pessoais-familiar-aluno>
                    <documentos-familiar-aluno [pessoaFisica]="familiar.pessoasFisica"></documentos-familiar-aluno>
                    <profissional-familiar-aluno [familiar]="familiar"></profissional-familiar-aluno>
                    <atendimento-apoio-aluno [pessoaFisica]="familiar.pessoasFisica"
                                   [beneficiosSociaisPessoaFisica]="familiar.pessoasFisica.beneficiosSociaisPessoaFisica">
                    </atendimento-apoio-aluno>
                </div>
            </form>

            <div fxLayout="row" *ngIf="!responsavel" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
                <div>
                    <button type="button" matTooltip="Adicionar familiar" mat-fab color="primary" (click)="addFamiliar()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

            <div fxLayout="row" *ngIf="responsavel && !responsavel.id" fxLayoutAlign="end center" fxLayoutGap="16px"
                 style="padding-top: 50px">
                <div>
                    <button type="button" matTooltip="Remover familiar" mat-fab color="primary" (click)="removeFamiliar()">
                        <mat-icon>delete_forever</mat-icon>
                    </button>
                </div>
            </div>

            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                 fxFlexFill>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

        <!-- ------------------ HISTÓRICO ------------------------ -->
        <mat-step style="padding-bottom: 20px">
            <ng-template matStepLabel>HISTÓRICO</ng-template>
            <listar-historico-aluno [aluno]="aluno"></listar-historico-aluno>

            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                 fxFlexFill>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

        <!-- UNIFORMES -->
        <mat-step style="padding-bottom: 20px" [stepControl]="formUniformes">
            <form #formUniformes="ngForm">
                <ng-template matStepLabel>UNIFORMES</ng-template>
                <app-uniforme-aluno [aluno]="aluno"></app-uniforme-aluno>
            </form>

            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                 fxFlexFill>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperNext>
                    <mat-icon>chevron_right</mat-icon>
                </button>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

        <!------------------ TURMA ------------------------>
        <mat-step [stepControl]="formMatricula">
            <form #formMatricula="ngForm">
                <ng-template matStepLabel>TURMA</ng-template>
                <app-matricula-aluno [matriculas]="matriculas" [idUnidadeAluno]="aluno.unidade.idUnidade"></app-matricula-aluno>
            </form>
            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                 fxFlexFill>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

        <!------------------ CONTRATOS ------------------------>
        <mat-step [stepControl]="formContrato">
            <form #formContrato="ngForm">
                <ng-template matStepLabel>CONTRATOS</ng-template>
                <aluno-contrato [listaAlunosContrato]="aluno.alunosContrato"
                                [isAtualizar]="isAtualizar"></aluno-contrato>
            </form>
            <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px"
                 fxFlexFill>
                <button type="button" mat-mini-fab name="botaoConfirmar" color="primary" matStepperPrevious>
                    <mat-icon>chevron_left</mat-icon>
                </button>
            </div>
        </mat-step>

    </mat-horizontal-stepper>
</div>

<!-- BOTOES -->
<div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
    <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button type="submit"
            name="botaoConfirmar"
            fxFlex="20%"
            color="primary"
            [disabled]="formCadastroDadosPessoais.invalid || formCadastroAcademico.invalid ||
                        formCadastroFamiliar.invalid || isDataResponsavelInvalida()"
            (click)="cadastrar()"> Cadastrar
    </button>

    <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button type="submit"
            name="botaoConfirmar"
            fxFlex="20%"
            color="primary"
            [disabled]="formCadastroDadosPessoais.invalid || formCadastroAcademico.invalid ||
                        formCadastroFamiliar.invalid || formUniformes.invalid || isDataResponsavelInvalida()"
            (click)="atualizar()">
        Atualizar
    </button>

    <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button type="submit"
            name="botaoRelatorio"
            fxFlex="20%"
            color="primary"
            (click)="abrirOpcoesRelatorio()">
        Relatórios
    </button>

    <button *ngIf="mostrarBotaoLimpar()" type="button"
            mat-raised-button
            fxFlex="20%"
            (click)="limpar()">
        Limpar
    </button>
    <button type="button"
            mat-raised-button
            fxFlex="20%"
            (click)="cancelar()">
        Cancelar
    </button>


</div>
